"use client"

import React from 'react';
import styles from "./SinglePlace.module.scss"
import {Skeleton} from "@mui/material";

export default function Preload() {
  const divs = [];
  for (let i = 0; i < 10; i++) {
    divs.push(<div key={i} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem'}}>
      <Skeleton variant="rectangular" animation={"pulse"} width={100} height={100}/>
      <Skeleton variant="rectangular" animation={"pulse"} width={'calc(100% - 100px)'} height={20}/>
    </div>);
  }
  return <div className={styles.skeleton}>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={350}/>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={20}/>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={20}/>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={20}/>
    {divs}
  </div>
}
